<template>
  <div
    class="modal modal-flex fade"
    id="modal-create-runs"
    tabindex="-1"
    role="dialog"
    aria-labelledby="flexModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <validation-observer
        ref="validation"
        v-slot="{ validate }"
        tag="div"
        class="modal-content"
      >
        <div class="modal-header">
          <button
            type="button"
            class="close"
            data-dismiss="modal"
            aria-hidden="true"
          >
            &times;
          </button>
          <h4 class="modal-title" id="flexModalLabel">Assign</h4>
        </div>
        <div class="modal-body">
          <div class="form-horizontal">
            <div class="form-group" v-if="!assignAll">
              <span class="col-sm-5 control-label">
                Number of stations selected:
              </span>
              <div class="col-sm-7">
                <p class="form-control-static">
                  {{ selectedStations.length }}
                </p>
              </div>
            </div>
            <div class="form-group" v-else>
              <span class="col-sm-12 text-center control-label">
                Assigning all stations to delivery runs.
              </span>
            </div>
            <!-- /.form-group -->
            <!-- /.form-group -->
          </div>
          <!-- /.form-horizontal -->

          <div class="alert alert-danger" v-if="stationServerError">
            {{ stationServerError }}.
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-default" data-dismiss="modal">
            Cancel
          </button>
          <async-button type="button" class="btn btn-green" :click="createCourier">
            Create Delivery Run
          </async-button>
        </div>
      </validation-observer>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
  </div>
  <!-- /.modal -->
</template>

<script>
import { mapActions } from 'vuex'
import { handleServerErrors } from 'utils'
import BaseModal from 'components/BaseModal'

export default {
  extends: BaseModal,

  props: {
    stations: Array,
    selectedStations: Array,
    assignAll: Boolean
  },

  data () {
    return {
      stationServerError: null,
      runs: 0,
      efficiency: 0.5,
      classes: ''
    }
  },

  methods: {
    ...mapActions('deliveryRuns', ['storeDeliveryRun', 'storeCourierDeliveryRun']),

    onModalHidden () {
      this.runs = null
      this.efficiency = 0.5
      this.$refs.validation.reset()
    },

    async createCourier () {
      const { selectedStations, stations, assignAll } = this

      await this.catchDeliveryRunCreationErrors(async () => {
        await this.storeCourierDeliveryRun({
          stations: assignAll ? stations.map(({ id }) => id) : selectedStations
        })
      })
    },

    async create () {
      const { runs, efficiency, selectedStations, stations, assignAll } = this
      await this.catchDeliveryRunCreationErrors(async () => {
        await this.storeDeliveryRun({
          runs,
          efficiency,
          stations: assignAll ? stations.map(({ id }) => id) : selectedStations,
          assignAll: assignAll ? 1 : 0
        })
      })
    },

    async catchDeliveryRunCreationErrors (callback) {
      this.stationServerError = null

      try {
        await callback()

        this.hideModal()

        this.$router.push({ name: 'delivery-runs.run-sheets' })
      } catch (error) {
        handleServerErrors(error, this.$refs.validation)

        // Handle errors with selected stations that can only be determined server side.
        if (error.response && error.response.status === 422) {
          const key = Object.keys(error.response.data.errors).find(value => value.match(/^stations\.\d+$/))

          if (key) {
            this.stationServerError = error.response.data.errors[key][0]
          }
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.d-flew {
  display: flex;
}
.justify-center {
  align-content: center;
}
.justify-between {
  justify-content: space-between;
}
</style>
